import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    flexGrow: 1,
  },
});

function Spacer({
  className,
  classes,
}) {
  return (
    <div className={classNames(classes.root, className)} />
  );
}

Spacer.defaultProps = {
  className: '',
};

Spacer.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default withStyles(styles)(Spacer);
